import { render, staticRenderFns } from "./ActFreeLegendWeapon.vue?vue&type=template&id=095c4870&scoped=true"
import script from "./ActFreeLegendWeapon.vue?vue&type=script&lang=js"
export * from "./ActFreeLegendWeapon.vue?vue&type=script&lang=js"
import style0 from "./ActFreeLegendWeapon.vue?vue&type=style&index=0&id=095c4870&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c4870",
  null
  
)

export default component.exports